// extracted by mini-css-extract-plugin
export default {"wrapper":"Content_wrapper__4y7u9","stretch":"Content_stretch__17SV6","container":"Content_container__l4m5x"};